'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeRoomControlCommands');

var KayleeRoomControlCommands = {
    fromJson: fromJson,
    getRoomControlCommands: getRoomControlCommands,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseArray.$fromJson(data, 'RoomControlCommands', reqProps, reqProps,
        function(data) { return getRoomControlCommands(data.$roomId); }
    );
}

// Returns a promise that resolves to the RoomControlCommands object when it is
// loaded.

function getRoomControlCommands(roomId) {
    var key = 'RoomControlCommands: ' + roomId;
    var commands = KayleeCache.get(key);

    if (commands === null) {
        commands = new RoomControlCommands(roomId);
        KayleeCache.put(key, commands);
    }

    return commands;
}

function RoomControlCommands(roomId) {
    this.$nodeType = 'roomControlCommands';
    this.$roomId = roomId;
    FirebaseArray.call(this,
        KayleeBase.app.database().ref('roomControlCommands/' + roomId));
    KayleeUtil.bindPrototypeMethods(RoomControlCommands.prototype,
        this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

RoomControlCommands.prototype = Object.create(FirebaseArray.prototype);
RoomControlCommands.prototype.constructor = RoomControlCommands;

RoomControlCommands.prototype.$toJson = function() {
    return FirebaseArray.prototype.$toJson.call(this,
        [ '$roomId' ], {});
};

RoomControlCommands.prototype.toString = function() {
    return '[RoomControlCommands (' + this.$id + ') (' +
        this.$items.length  + ' commands)]';
};

RoomControlCommands.prototype.$remove = function(commandId) {
    return this.$ref.child(commandId).set(null);
};

module.exports = KayleeRoomControlCommands;
